/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { PowerCalendarDay, PowerCalendarPublicAPI, PowerCalendarWeek } from 'ember-power-calendar';
import { MAX_CUSTOM_DAYS_COUNT } from 'cio/utils/workflow-metrics';
import moment from 'moment-timezone';

interface MetricsDatePickerDaysArgs {
  Args: {
    day: PowerCalendarDay;
    calendar: PowerCalendarPublicAPI;
    weeks: PowerCalendarWeek[];
    minDateDaysBeforeToday: number | null;
    maxDate: moment.Moment;
  };
  Element: HTMLDivElement;
}

export default class DatePickerDaysComponent extends Component<MetricsDatePickerDaysArgs> {
  get minDateDaysBeforeToday() {
    return this.args.minDateDaysBeforeToday ?? MAX_CUSTOM_DAYS_COUNT;
  }

  get isAfterMaxDate() {
    return this.args.day.moment?.isAfter(this.args.maxDate);
  }
}
